<template>
  <div class="page-taobaoActivity" :style="`background:${pageBgTheme}`">
    <Navigation :title="pageTitle" :backgroundColor="pageBgTheme" fontColor="#ffffff" />
    <div
      v-for="(curActivityItem, curActivityIndex) in curActivityList"
      :key="curActivityItem.taobaoPageUrl"
    >
      <img class="img-enter" :src="curActivityItem.taobaoPageTopImg" @click="handleClickBtn(1, curActivityIndex)" />
      <ul class="btn-wrap">
        <li
          :class="`btn-item share${curActivityIndex + 1}`"
          :data-clipboard-text="curActivityItem.shortShareUrl"
          @click="handleClickBtn(0, curActivityIndex)"
        >
          <md-activity-indicator
            v-show="authTbAccountRelationId && !curActivityItem.shortShareUrl"
            class="loading-indicator"
            type="carousel"
            :size="10"
            color="#ff9500"
            text-color="#ff9500"
          >链接生成中</md-activity-indicator>
          <span v-show="!authTbAccountRelationId || curActivityItem.shortShareUrl">复制推广链接,分享好友</span>
        </li>
        <li class="btn-item buy" @click="handleClickBtn(1, curActivityIndex)">去抢购</li>
      </ul>
      <div class="goods-list" v-if="curActivityItem.taobaoPageImgList.length > 0">
        <img
          class="goods-item"
          @click="handleClickBtn(1)"
          v-for="imgItem in curActivityItem.taobaoPageImgList"
          :key="imgItem"
          :src="formatHttpImg(imgItem)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Consts from '@/common/consts'
import Navigation from '@/components/navigation'
import Clipboard from 'clipboard'
import { Toast, ActivityIndicator } from 'mand-mobile'
import { isWeiXin, isDshApp } from '@/utils/help'
import LoginService from '@/services/login'
import _AP from '@/utils/ap'
import { mapGetters } from 'vuex'
const activityList = [
  {
    taobaoPageTopImg: 'https://dshui-wap.oss-cn-hangzhou.aliyuncs.com/taobao_activity/activity1.jpg', // 大额优惠券
    taobaoPageUrl: 'https://mos.m.taobao.com/union/supercoupon?pid=mm_98092366_700500314_110116550431', // 活动活动页详情地址
    taobaoPageImgList: [
      // 'https://dshui-wap.oss-cn-hangzhou.aliyuncs.com/taobao_activity/20200319/1.jpg',
      // 'https://dshui-wap.oss-cn-hangzhou.aliyuncs.com/taobao_activity/20200319/2.jpg',
      // 'https://dshui-wap.oss-cn-hangzhou.aliyuncs.com/taobao_activity/20200319/3.jpg',
      // 'https://dshui-wap.oss-cn-hangzhou.aliyuncs.com/taobao_activity/20200319/4.jpg',
      // 'https://dshui-wap.oss-cn-hangzhou.aliyuncs.com/taobao_activity/20200319/5.jpg',
      // 'https://dshui-wap.oss-cn-hangzhou.aliyuncs.com/taobao_activity/20200319/6.jpg',
      // 'https://dshui-wap.oss-cn-hangzhou.aliyuncs.com/taobao_activity/20200319/7.jpg',
      // 'https://dshui-wap.oss-cn-hangzhou.aliyuncs.com/taobao_activity/20200319/8.jpg',
      // 'https://dshui-wap.oss-cn-hangzhou.aliyuncs.com/taobao_activity/20200319/9.jpg',
      // 'https://dshui-wap.oss-cn-hangzhou.aliyuncs.com/taobao_activity/20200319/10.jpg',
      // 'https://dshui-wap.oss-cn-hangzhou.aliyuncs.com/taobao_activity/20200319/11.jpg',
    ],
  },
  {
    taobaoPageTopImg: 'https://dshui-wap.oss-cn-hangzhou.aliyuncs.com/taobao_activity/activity2.jpg', //  品牌尖货
    taobaoPageUrl: 'https://mos.m.taobao.com/taokeapp/20181111ysppcjbkg?pid=mm_98092366_700500314_110116550431', // 活动活动页详情地址
    taobaoPageImgList: [],
  },
]
export default {
  name: 'taobaoActivity',
  components: {
    Navigation,
    [ActivityIndicator.name]: ActivityIndicator,
  },
  data() {
    return {
      pageTitle: '淘宝优惠',
      pageBgTheme: 'rgb(241, 0, 65)',
      curActivityList: [],
    }
  },
  computed: {
    ...mapGetters(['token', 'authTbAccountName', 'authTbAccountRelationId']),
  },
  watch: {
    authTbAccountRelationId() {
      this.initShortUrl()
    },
  },
  created() {
    for (let i = 0; i < activityList.length; i++) {
      const activityItem = activityList[i]
      this.curActivityList.push({
        webUrl: '',
        shortShareUrl: '',
        taobaoPageUrl: activityItem.taobaoPageUrl,
        taobaoPageTopImg: activityItem.taobaoPageTopImg,
        taobaoPageImgList: activityItem.taobaoPageImgList,
      })
    }
    this.initShortUrl()
  },
  mounted() {
    const clipboard1 = new Clipboard('.btn-item.share1')
    clipboard1.on('success', e => {
      if (this.curActivityList[0] && this.curActivityList[0].shortShareUrl) {
        Toast.succeed('分享链接复制成功', 1500)
      }
      e.clearSelection()
    })
    const clipboard2 = new Clipboard('.btn-item.share2')
    clipboard2.on('success', e => {
      if (this.curActivityList[1] && this.curActivityList[1].shortShareUrl) {
        Toast.succeed('分享链接复制成功', 1500)
      }
      e.clearSelection()
    })
  },
  methods: {
    /**
     * 点击分享/去抢购, type: 0:分享 1:去抢购
     */
    handleClickBtn(type, curActivityIndex) {
      if (this.token) {
        if (this.authTbAccountName && this.authTbAccountRelationId) {
          // 已授权淘宝账户并绑定关联ID
          if (type === 1) {
            this.jumpTaobaoActivityPage(curActivityIndex)
          } else {
            this.initShortUrl()
          }
        } else {
          LoginService.checkBindTb((isBind, data) => {
            if (isBind && data && data.tbRelationId) {
              // 已授权淘宝账户并绑定关联ID
              if (type === 1) {
                this.jumpTaobaoActivityPage(curActivityIndex)
              } else {
                this.initShortUrl()
              }
            }
          })
        }
      } else {
        this.jumpLoginPage()
      }
    },
    /**
     * 跳转至登录页面
     */
    jumpLoginPage() {
      this.$router.push({ name: 'login' })
    },
    /**
     * 跳转至淘宝活动页面
     */
    jumpTaobaoActivityPage(curActivityIndex) {
      this.setWebUrl()
      const webUrl = this.curActivityList[curActivityIndex].webUrl
      if (isWeiXin()) {
        _AP.redirect(`https://pub.${Consts.WAP_HOST}/wx_jump_taobao.htm`, webUrl)
      } else if (isDshApp()) {
        window.location.href = webUrl
      } else {
        window.location.href = webUrl
      }
    },
    /**
     * 初始化短链接
     */
    initShortUrl() {
      if (this.token && this.authTbAccountName && this.authTbAccountRelationId) {
        this.setWebUrl()
        for (let i = 0; i < this.curActivityList.length; i++) {
          if (!this.curActivityList[i].shortShareUrl) {
            this.fetchShortShareUrl(i)
          }
        }
      }
    },
    /**
     * 设置web url
     */
    setWebUrl() {
      for (let i = 0; i < this.curActivityList.length; i++) {
        this.curActivityList[i].webUrl = `${this.curActivityList[i].taobaoPageUrl}&relationId=${this.authTbAccountRelationId}`
      }
    },
    /**
     ** 获取短链接
     */
    fetchShortShareUrl(activityId) {
      const pageUrl = _AP.getRedirectUrl(`https://pub.${Consts.WAP_HOST}/wx_jump_taobao.htm`, this.curActivityList[activityId].webUrl)
      this.$http.common
        .getShortUrl(pageUrl)
        .then(res => {
          this.curActivityList[activityId].shortShareUrl = res.data.shorturl
        })
        .catch(() => {
          this.curActivityList[activityId].shortBuyUrl = pageUrl
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.page-taobaoActivity {
  position: relative;
  width: 100%;
  min-height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  .img-enter {
    margin-top: 50px;
    width: 90%;
    margin-left: 5%;
    border-radius: 10px;
  }
  .btn-wrap {
    margin-top: 50px;
    width: 90%;
    margin-left: 5%;
    display: flex;
    align-items: center;
    .btn-item {
      display: inline-block;
      width: 48%;
      height: 72px;
      line-height: 72px;
      text-align: center;
      border-radius: 100px;
      background: #ff9500;
      color: #fff;
      font-size: 24px;
      &.buy {
        margin-left: 4%;
        font-size: 32px;
        font-weight: bold;
      }
      &.share {
        background-color: #ffeded;
        border: 1px solid #ff0036;
        color: #ff0036;
      }
      &:active {
        opacity: 0.5;
      }
      .loading-indicator {
        display: inline-block;
        margin-bottom: 0;
        .md-activity-indicator-svg {
          height: 0.15rem !important;
        }
      }
    }
  }
  .goods-list {
    .goods-item {
      width: 100%;
    }
  }
}
</style>
